export default {
  'actions.login': 'Login',
  'actions.logout': 'Logout',
  'actions.register': 'Register',
  'actions.resetPassword': 'Reset Password',
  'actions.sendVerificationEmail': 'Send Verification Email',
  'actions.verifyEmail': 'Verify Email',
  'actions.create': 'Create',
  'actions.view': 'View',
  'actions.viewAll': 'View All',
  'actions.viewDetails': 'View Details',
  'actions.assign': 'Assign',
  'actions.unAssign': 'Un-Assign',
  'actions.assignAll': 'Assign All',
  'actions.unAssignAll': 'Un-Assign All',
  'actions.unassigned': 'Unassigned',
  'actions.generate': 'Generate',
  'actions.manage': 'Manage',
  'actions.change': 'Change',
  'actions.sendMessage': 'Send',
  'actions.sort': 'Sort',
  'actions.ok': 'Ok',
  'actions.publish': 'Publish',
  'actions.refresh': 'Refresh',
  'actions.draft': 'Draft',
  'actions.hide': 'Hide {{type}}',
  'actions.unHide': 'Show {{type}}',
  'actions.like': 'Like',
  'actions.unLike': 'Unlike',
  'actions.more': 'More',
  'actions.time': 'Time',
  'actions.share': 'Share',
  'actions.shareOn': 'Share on {{type}}',
  'actions.export': 'Export',
  'actions.edit': 'Edit {{type}}',
  'actions.show': 'Show {{type}}',
  'actions.showOnMap': 'Show on Map',
  'actions.download': 'Download file',
  'actions.exportAs': 'Export as a {{type}}',
  'actions.email': 'Send Email',
  'actions.copy': 'Copy',
  'actions.copied': 'Copied',
  'actions.save': 'Save',
  'actions.activate': 'Activate',
  'actions.deactivate': 'Deactivate',
  'actions.preview': 'Preview',
  'actions.hold': 'Hold',
  'actions.delete': 'Delete',
  'actions.deleteEntity': 'Delete {{type}}',
  'actions.update': 'Update',
  'actions.upload': 'Upload',
  'actions.reload': 'Reload',
  'actions.screenshot': 'Screenshot',
  'actions.views': 'Views',
  'actions.close': 'Close',
  'actions.confirm': 'Confirm',
  'actions.add': 'Add {{type}}',
  'actions.back': 'Back',
  'actions.cancel': 'Cancel',
  'actions.select': 'Select',
  'actions.unselect': 'Unselect',
  'actions.setAs': 'Set as {{type}}',
  'actions.search': 'Search',
  'actions.new': 'New',
  'actions.next': 'Next',
  'actions.prev': 'Previous',
  'actions.yes': 'Yes',
  'actions.no': 'No',
  'actions.leave': 'Leave',
  'actions.stay': 'Stay',
  'actions.clone': 'Clone',
  'actions.cloneEntity': 'Clone {{type}}',
};
